import { render } from "./FieldLabel.vue?vue&type=template&id=718c2480&scoped=true"
import script from "./FieldLabel.vue?vue&type=script&lang=js"
export * from "./FieldLabel.vue?vue&type=script&lang=js"

import "./FieldLabel.vue?vue&type=style&index=0&id=718c2480&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-718c2480"]])

export default __exports__